import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    items: [],
};

const getAvailableQuantity = (item) => {
    const availableQuantity = Number(item.availableQuantity ?? item.availbelQuantity ?? item.qty);
    return Number.isFinite(availableQuantity) ? availableQuantity : null;
};

export const cart = createSlice({
    name: 'cart',
    initialState,
    reducers: {
        addToCart: (state, action) => {
            const item = state.items.find((item) => item._id === action.payload._id);

            if (item) {
                const availableQuantity = getAvailableQuantity(item) ?? getAvailableQuantity(action.payload);
                const requestedQuantity = item.quantity + action.payload.quantity;
                item.quantity = availableQuantity === null
                    ? requestedQuantity
                    : Math.min(requestedQuantity, availableQuantity);
            } else {
                const availableQuantity = getAvailableQuantity(action.payload);
                state.items.push({
                    ...action.payload,
                    quantity: availableQuantity === null
                        ? action.payload.quantity
                        : Math.min(action.payload.quantity, availableQuantity),
                });
            }
        },
        removeFromCart: (state, action) => {
            state.items = state.items.filter((item) => item._id !== action.payload);
        },
        emptyCart: (state, action) => {
            state.items = [];
        },
        increamentQuantity: (state, action) => {
            const item = state.items.find((item) => item._id === action.payload._id);
            if (item) {
                const availableQuantity = getAvailableQuantity(item);
                const requestedQuantity = item.quantity + 1;
                item.quantity = availableQuantity === null
                    ? requestedQuantity
                    : Math.min(requestedQuantity, availableQuantity);
            }
        },
        decrementQuantity: (state, action) => {
            const item = state.items.find((item) => item._id === action.payload._id);
            if (item.quantity === 1) {
                item.quantity = 1;
            } else {
                item.quantity--;
            }
        },
    },
});

export const { addToCart, removeFromCart, emptyCart, decrementQuantity, increamentQuantity } = cart.actions;
export default cart.reducer;
